/**
 *
 *  Application entry point. 
 * 
 */


 /**
 * SCSS entry.  
 */
import '../scss/style.scss';

import { tns } from 'tiny-slider/src/tiny-slider.module.js';
import Masonry from 'masonry-layout/masonry.js';
import imagesLoaded from 'imagesloaded/imagesloaded.js';


if(document.querySelector('.slideshow .slideshow-content')) {   
    var slider = tns({
        container: '.slideshow .slideshow-content',
        items: 1,
        slideBy: 1,
        mouseDrag: true,
        autoplay: false,
        controls: false,
        nav: true,
        arrowKeys: true,
        navContainer: '.slideshow .slideshow-nav',
        responsive: {
            768: {
                items: 3
            }
        }
    });
}
    
var artistImages = document.getElementsByClassName('artist-main-image');
if(artistImages) {
    for (let i = 0; i < artistImages.length; i++) {
        const element = artistImages[i];
    }
}

/**
 * Custom file upload buttons
 */
var fileUploadButton = document.querySelector('.input-file-container input[type="file"]');
var fileUploadFeedback = document.querySelector('#input-file-feedback');
var fileUploadInfo = document.querySelector('#input-file-info');

if(fileUploadFeedback) {
    fileUploadFeedback.addEventListener('click', function() {
        fileUploadButton.value = "";
        fileUploadFeedback.innerHTML = "";
        fileUploadFeedback.classList.remove('input-file-feedback-visible');
    })
}

if(fileUploadButton) {
    fileUploadButton.addEventListener('change', function() {
        fileUploadInfo.classList.remove('input-file-info-visible');
        fileUploadFeedback.classList.remove('input-file-feedback-visible');
        // Extract filename
        var fullPath = this.value;
        console.log("SIZE:" + this.files[0].size);
        if(this.files[0] && this.files[0].size > 5000000) {
            this.value = '';
            fileUploadInfo.classList.add('input-file-info-visible');
        } else {
            if(fullPath != '') {
                var startIndex = (fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/'));
                var filename = fullPath.substring(startIndex);
                if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
                    filename = filename.substring(1);
                }
                fileUploadFeedback.innerHTML = filename;
                fileUploadFeedback.classList.add('input-file-feedback-visible');
            } 
        }

    });
}


/**
 * 
 * Masonry Grid
 * 
 */

var gridElement = document.querySelector('.grid');
if(gridElement) {
    var masonry = new Masonry(gridElement, {
        itemSelector: '.grid-item',
        columnWidth: '.grid-item'
    });

    // Force Masonry to re-render layout when images are loaded
    imagesLoaded(gridElement, function() {
        masonry.layout();
    });

}


/**
 * 
 * LightGallery
 * lightgallery.js
 * 
 */
var gallery = lightGallery(document.querySelector('.gallery'), {
    download: false,
    selector: 'a'
});



/**
 * 
 * Intersection observer 
 * 
 */

var intersectionOptions = {
    root: null, // observe viewport
    rootMargin: '0px',
    threshold: 0.01
}
var observer = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
        entry.target.classList.toggle('inviewport', entry.intersectionRatio > intersectionOptions.threshold);
    });
}, intersectionOptions);
var targets = document.getElementsByClassName('artist');
for(var i = targets.length - 1; i >= 0; i--) {
    observer.observe(targets[i]);
}


// WEBPACK FOOTER //
// ./js/index.js